<section class="assignment-services">
  <h2 class="pull-left mt0">Services</h2>
  <a [routerLink]="['initiation']" class="btn-link">View status &raquo;</a>

  @if (workflows) { @for (workflow of workflows; track workflow) {
  <div>
    @if (workflow.services.length !== 0) {
    <div class="workflow">
      <h2 class="block-header d-flex justify-content-between">
        <div>{{ workflow.name }}</div>
        @if (workflow.name === 'DSP Services') {
        <div>
          <a [routerLink]="'./services/dsp'">Manage Bundle&nbsp;&gt;&gt;</a>
        </div>
        }
      </h2>
      <div class="block-content">
        @for (service of workflow.services; track service) {
        <div class="service">
          <table class="table-fixed">
            <tr>
              <td>
                @if (isVisaImmigrationService(service.id)) {
                <span
                  (click)="onServiceOpenClick(service.id)"
                  class="me-3 fa fa-chevron-right cursor-pointer"
                ></span>
                }
                <a [routerLink]="toServiceLink(service.id)">
                  @for (status of service.progress; track status) {
                  <service-status-indicator
                    [status]="status.value"
                    [tooltip]="status.value"
                  ></service-status-indicator>
                  }
                  {{ service.label }}
                </a>
              </td>
              @if (isVisaImmigrationService(service.id)) {
              <td>{{ getServiceStatus(service.progress) }}</td>
              }
            </tr>
          </table>
          @if (showAllServiceStatuses(service.id)) {
          <table class="mt-2 table-fixed all-service-statuses">
            @for (status of service.progress; track status) {
            <tr>
              <td>
                <service-status-indicator
                  [status]="status.value"
                ></service-status-indicator>
                {{ status.label }}
              </td>
              <td>{{ status.value }}</td>
            </tr>
            }
          </table>
          }
        </div>
        }
      </div>
    </div>
    }
  </div>
  } } @if (hhgWorkflow) {
  <div class="workflow">
    <h2 class="block-header">{{ hhgWorkflow.name }}</h2>
    <div class="block-content">
      @for (service of hhgWorkflow.services; track service) {
      <div class="service">
        <a
          class="hhg-link"
          (click)="
            navigateToHhg(service.id, service.assignmentServiceInstanceId)
          "
        >
          @for (status of service.progress; track status) {
          <service-status-indicator
            [status]="status.value"
            [tooltip]="status.value"
          ></service-status-indicator>
          }
          {{ service.label }}
        </a>
        @if (hasAddresses(service.addresses)) {
        <div class="d-flex flex-nowrap ps-4 mt-2 text-black">
          <div class="d-flex align-items-center">
            {{ service.addresses.hhgOriginAddress.address.city }}&nbsp;
            <country-flag
              [code]="service.addresses.hhgOriginAddress.address.country.iso2"
              [tooltip]="
                service.addresses.hhgOriginAddress.address.country.name
              "
            ></country-flag>
          </div>
          <div class="d-flex align-items-center px-3">
            <icon type="arrow-right-short"></icon>
          </div>
          <div class="d-flex flex-column justify-content-center">
            @for (destinationAddress of
            service.addresses.hhgDestinationAddresses; track destinationAddress)
            {
            <div>
              {{ destinationAddress.address.city }}&nbsp;
              <country-flag
                [code]="destinationAddress.address.country.iso2"
                [tooltip]="destinationAddress.address.country.name"
              ></country-flag>
            </div>
            }
          </div>
        </div>
        }
      </div>
      }
    </div>
  </div>
  } @if (!hasServices) {
  <no-data> There are no services associated with this assignment. </no-data>
  }
</section>
